
export enum OperationItemStatus {
  Unkwnon = 1,
  Success = 2,
  Failed = 3
}
